<app-product-template *ngIf="productTemplate" [productTemplate]="productTemplate" ></app-product-template>
<app-alert-error [error]="error" [showAppLogo]="true"></app-alert-error>
<app-loading-spinner *ngIf="isLoading"></app-loading-spinner>

